import p1_img from "./product_1.png";
import p2_img from "./product_35.png";
import p3_img from "./product_20.png";
import p4_img from "./product_8.png";
import p5_img from "./product_29.png";
import p6_img from "./product_36.png";
import p7_img from "./product_17.png";
import p8_img from "./product_28.png";

let new_collections = [
  {
    id: 12,
    name: "Butter Poat",
    image: p1_img,
    new_price: 50.0,
    old_price: 80.5,
  },
  {
    id: 35,
    name: "Lining Glass",
    image: p2_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 14,
    name: "Frosted Coloured Glass",
    image: p3_img,
    new_price: 60.0,
    old_price: 100.5,
  },
  {
    id: 8,
    name: "Frosted Coloured Cup With Wooden Lid",
    image: p4_img,
    new_price: 100.0,
    old_price: 150.0,
  },
  {
    id: 15,
    name: "Tempered Glass Finish",
    image: p5_img,
    new_price: 150.0,
    old_price: 180.5,
  },
  {
    id: 2,
    name: "Red Glass",
    image: p6_img,
    new_price: 100.0,
    old_price: 120.5,
  },
  {
    id: 17,
    name: "Diamond Candy Metallic",
    image: p7_img,
    new_price: 130.0,
    old_price: 150.5,
  },
  {
    id: 28,
    name: "Holographic U Glass",
    image: p8_img,
    new_price: 50.0,
    old_price: 80.0,
  },
];

export default new_collections;
